var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1Drier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 42H16v-8l3-.56v-7.63l2 2 2-2v6.89l8.82-1.63a6.18 6.18 0 0012.36 0L53 32.81v-6.93l2 2 2-2v7.72l3 .59V42H50v23H26V42zM67 3v70H9V3h58zm-4 18H13v48h50V21zm0-14H13v10h50V7zm-4 3h-4v4h4v-4zm-7 0h-4v4h4v-4zm-13 0H17v4h22v-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Drier.467265f1.svg";
export { SvgD1Drier as ReactComponent };